import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaIntersectionNode } from './TypedNode'
import { SchemaIntersectionModel } from './ViewModel'

export const SchemaIntersectionPlugin = createSchemaPlugin(
  'Schema.Intersection',
  SchemaIntersectionModel,
  SchemaIntersectionNode
)
